import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import "../../geometry.js";
import i from "../../Viewpoint.js";
import s from "../../core/Accessor.js";
import { addFrameTask as e } from "../../core/scheduling.js";
import { property as o } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as n } from "../../core/accessorSupport/decorators/subclass.js";
import a from "../ViewAnimation.js";
import { easingFunctions as r, parse as h } from "./unitBezier.js";
import { copy as p } from "./viewpointUtils.js";
import c from "../../geometry/Point.js";

var m = /*#__PURE__*/function () {
  function m(t, i, s, e) {
    _classCallCheck(this, m);

    var o = t.targetGeometry,
        n = i.targetGeometry;
    e ? "string" == typeof e && (e = h(e) || r.ease) : e = r.ease, this.easing = e, this.duration = s, this.sCenterX = o.x, this.sCenterY = o.y, this.sScale = t.scale, this.sRotation = t.rotation, this.tCenterX = n.x, this.tCenterY = n.y, this.tScale = i.scale, this.tRotation = i.rotation, this.dCenterX = this.tCenterX - this.sCenterX, this.dCenterY = this.tCenterY - this.sCenterY, this.dScale = this.tScale - this.sScale, this.dRotation = this.tRotation - this.sRotation, this.dRotation > 180 ? this.dRotation -= 360 : this.dRotation < -180 && (this.dRotation += 360);
  }

  _createClass(m, [{
    key: "applyRatio",
    value: function applyRatio(t, i) {
      var s = this.easing(i);
      var e, o, n, a;
      i >= 1 ? (e = this.tCenterX, o = this.tCenterY, n = this.tRotation, a = this.tScale) : (e = this.sCenterX + s * this.dCenterX, o = this.sCenterY + s * this.dCenterY, n = this.sRotation + s * this.dRotation, a = this.sScale + s * this.dScale), t.targetGeometry.x = e, t.targetGeometry.y = o, t.scale = a, t.rotation = n;
    }
  }]);

  return m;
}();

var u = /*#__PURE__*/function (_s) {
  _inherits(u, _s);

  var _super = _createSuper(u);

  function u(t) {
    var _this;

    _classCallCheck(this, u);

    _this = _super.call(this, t), _this.duration = 200, _this.transition = null, _this.easing = r.ease, _this.view = null, _this.viewpoint = null, _this.viewpoint = new i({
      targetGeometry: new c(),
      scale: 0,
      rotation: 0
    }), _this._updateTask = e({
      postRender: _this._postRender.bind(_assertThisInitialized(_this))
    }), _this._updateTask.pause();
    return _this;
  }

  _createClass(u, [{
    key: "destroy",
    value: function destroy() {
      this._updateTask.remove(), this._updateTask = null;
    }
  }, {
    key: "animate",
    value: function animate(t, i, s) {
      var _this2 = this;

      this.stop();
      var e = this.viewpoint;
      p(e, i), this.transition = new m(this.viewpoint, t.target, s && s.duration || this.duration, s && s.easing || this.easing);

      var o = function o() {
        _this2.animation === t && _this2._updateTask && ("finished" === t.state && (_this2.transition.applyRatio(_this2.viewpoint, 1), _this2.view.state && (_this2.view.state.viewpoint = _this2.viewpoint.clone())), _this2.animation = null, _this2.updateFunction = null);
      };

      return t.when(o, o), this._startTime = performance.now(), this._updateTask.resume(), this.animation = t, t;
    }
  }, {
    key: "animateContinous",
    value: function animateContinous(t, i) {
      var _this3 = this;

      this.stop(), this.updateFunction = i, this.viewpoint = t;

      var s = new a({
        target: t.clone()
      }),
          e = function e() {
        _this3.animation === s && _this3._updateTask && (_this3.animation = null, _this3.updateFunction = null);
      };

      return s.when(e, e), this._startTime = performance.now(), this._updateTask.resume(), this.animation = s, s;
    }
  }, {
    key: "stop",
    value: function stop() {
      this.animation && (this.animation.stop(), this.animation = null, this.updateFunction = null);
    }
  }, {
    key: "_postRender",
    value: function _postRender(t) {
      var i = this.animation;

      if (i && i.state !== a.State.STOPPED) {
        if (this.updateFunction) this.updateFunction(this.viewpoint, t.deltaTime);else {
          var _t = (performance.now() - this._startTime) / this.transition.duration,
              _i = _t >= 1;

          this.transition.applyRatio(this.viewpoint, _t), _i && this.animation.finish();
        }
        this.view.state && (this.view.state.viewpoint = this.viewpoint.clone());
      } else this._updateTask.pause();
    }
  }]);

  return u;
}(s);

t([o()], u.prototype, "animation", void 0), t([o()], u.prototype, "duration", void 0), t([o()], u.prototype, "transition", void 0), t([o()], u.prototype, "easing", void 0), t([o()], u.prototype, "view", void 0), t([o()], u.prototype, "viewpoint", void 0), u = t([n("esri.views.2d.AnimationManager")], u);
var d = u;
export { d as default };